import { Menu } from "@fundacao/shared-components/esm/ie";
import React, { useEffect } from "react";

function MenuAngular() {
  useEffect(() => {
    document.body.id = 'menu-angular';
  }, []);

  return <Menu menuAngular />;
};

export default MenuAngular;